import { observer } from 'mobx-react';
import FoodicsLogListRowSkeleton from '../../components/FoodicsLogListRowSkeleton/FoodicsLogListRowSkeleton';
import { FOODICS_LOG_COLUMN } from '~/view/screens/FoodicsLogScreen/screens/FoodicsLog/constants/foodicsLogRow';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import { emptyArray } from 'src/utils/helpers';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import { PaginationType } from 'src/view/components/Controls/PaginationOld/types';
import foodicsLogStore from 'src/view/screens/FoodicsLogScreen/screens/FoodicsLog/store/foodicsLogStore';
import FoodicsLogListRow from 'src/view/screens/FoodicsLogScreen/screens/FoodicsLog/components/FoodicsLogListRow/FoodicsLogListRow';
import './style.scss';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';

const FoodicsLogList = (): JSX.Element => {
  const { pagination } = foodicsLogStore;

  const isListLoading = (pagination.loading || pagination.refreshing) && !pagination.total;
  const emptyListTitle = 'no_foodics_log_found';

  interface ITitleProps {
    titleName: string | null;
    className: FOODICS_LOG_COLUMN;
  }

  const FoodicsLogColumnTitle: React.FC<ITitleProps> = ({ className, titleName }: ITitleProps) => {
    if (!titleName) {
      titleName = className;
    }

    return <ColumnTitle<FOODICS_LOG_COLUMN> title={titleName} className={`cell-${className}`} />;
  };

  const FoodicsLogColumnTitles: React.FC<any> = (): JSX.Element => {
    return (
      <div className="d-flex flex-row pb-4 foodics-log-headers">
        <FoodicsLogColumnTitle titleName={null} className={FOODICS_LOG_COLUMN.TIME} />
        <FoodicsLogColumnTitle titleName={null} className={FOODICS_LOG_COLUMN.USER} />
        <FoodicsLogColumnTitle titleName="Action" className={FOODICS_LOG_COLUMN.ACTION} />
        <FoodicsLogColumnTitle titleName={null} className={FOODICS_LOG_COLUMN.SYNC_DATA} />
        <FoodicsLogColumnTitle titleName={null} className={FOODICS_LOG_COLUMN.SYNC_FROM} />
        <FoodicsLogColumnTitle titleName={null} className={FOODICS_LOG_COLUMN.DAILY_SYNC} />
      </div>
    );
  };

  return (
    <div className="d-flex flex-column flex-1 mt-4">
      {!pagination.data.length && !pagination.loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center mt-6">
          <img src={formatImagePath(`${Icons.BranchesTree}.svg`)} alt={emptyListTitle} className="image__no-found mb-6" />
          <p className="family-medium text-size-24 color-gray2">{localeStore.t(emptyListTitle)}</p>
        </div>
      ) : (
        <ScrollableBlock
          showScrollbar
          scrollClassName="d-flex flex-column full-height pr-3"
          className="overflow-y-scroll mb-3 foodics-log"
          direction="vertical"
        >
          <FoodicsLogColumnTitles />

          {isListLoading
            ? emptyArray().map((_, index) => <FoodicsLogListRowSkeleton key={'skeleton-' + String(index)} />)
            : pagination.data.map((foodicsLog) => <FoodicsLogListRow key={foodicsLog.id} foodicsLog={foodicsLog} />)}
        </ScrollableBlock>
      )}

      <Pagination
        pagination={pagination}
        showPaginationInfo={true}
        showMorePageButtons={true}
        type={PaginationType.ARROW}
        onChange={foodicsLogStore.fetchFoodicsLogList}
      />
    </div>
  );
};

export default observer(FoodicsLogList);
